var VersionCompare = /** @class */ (function () {
    function VersionCompare() {
    }
    /**
     * Compare version strings
     *
     * @static
     * @param {string} first First version number for the compare
     * @param {string} second Second version number for the compare
     * @returns {number} 1 if the second is larger, -1 if the first is larger, 0 if the same
     */
    VersionCompare.compare = function (first, second) {
        if (first === second) {
            return 0;
        }
        var array = [first, second];
        var splitter = array.map(function (a) { return a.split('.').map(function (n) { return +n + 100000; }); });
        var max_length = 0;
        splitter.forEach(function (s) {
            if (s.length > max_length) {
                max_length = s.length;
            }
        });
        splitter.forEach(function (s) {
            for (var index = s.length; index < max_length; index++) {
                s.push(100000);
            }
        });
        var original_array = splitter.map(function (s) { return s.join('.'); })
            .map(function (a) { return a.split('.').map(function (n) { return +n - 100000; }).join('.'); });
        array = splitter.map(function (s) { return s.join('.'); }).sort()
            .map(function (a) { return a.split('.').map(function (n) { return +n - 100000; }).join('.'); });
        if (array[0] === array[1]) {
            return 0;
        }
        if (array[1] === original_array[1]) {
            return 1;
        }
        else if (array[0] === original_array[1]) {
            return -1;
        }
    };
    VersionCompare.same_or_higher = function (version, minimum) {
        return VersionCompare.compare(version, minimum) <= 0;
    };
    return VersionCompare;
}());
export { VersionCompare };
